const API_URL = process.env.REACT_APP_API_URL;

export const PrivacyFormService = {
    async submitRequest({ requestType, firstName, lastName, email }) {
        const response = await fetch(`${API_URL}/privacy`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ requestType, firstName, lastName, email }),
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.message ?? `Request failed with status ${response.status}`);
        }

        return response.json();
    },
};
